// ============================================
// Google Haritalara Reklam Vermek - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleHaritalaraReklamVermekContent: BlogContent = {
  tableOfContents: [
    { id: "harita-reklamlari", title: "Harita Reklamları Nedir?" },
    { id: "kampanya-kurulumu", title: "Kampanya Kurulumu" },
    { id: "hedefleme", title: "Hedefleme Stratejileri" },
    { id: "optimizasyon", title: "Optimizasyon" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google Haritalara reklam vermek</strong> için kampanya kurulum ve optimizasyon rehberi."
    }
  ]
};

export default googleHaritalaraReklamVermekContent;
